// UPS WWEX (WWEX Parcel, provider 4690) resells UPS, so these mirror UpsWalletService
// but carry their own ShippingServiceIDs.
export const UpsWwexService = Object.freeze({
  Ground: '429979',
  GroundSaver: '429983',
  ThreeDaySelect: '429978',
  NextDayAirSaver: '429975',
  NextDayAir: '429974',
  SecondDayAir: '429976',
});
